import React, { Component, Fragment, useState } from 'react';


import {
  CircularProgress,
  LinearProgress,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

export default function AlertDialog() {
  const [open, setOpen] = React.useState(true);
  const interval = 5000 //3 segundos

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {

    setInterval(() => {
      setOpen(false);
    }, interval);

  };

  return (
    <div>
      <Dialog
        titleStyle={{ textAlign: "center" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableEscapeKeyDown={false}
      >
        <DialogTitle id="alert-dialog-title">{"Cargando..."}</DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-description" style={{ textAlign: "center" }}>
            <CircularProgress />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
